const localePt = {
  pt: {
    TITLE_1: 'Olá,',
    TITLE_2: 'O que você precisa fazer hoje?',
    DESCRIPTION:
      'Acesse as principais ferramentas de gestão de talentos em sua organização:',

    PERFORMANCE_COMPETENCES_LABEL: 'Desempenho',
    PERFORMANCE_COMPETENCES_TITLE: 'Objetivos e competências',
    PERFORMANCE_COMPETENCES_DESCRIPTION:
      'Quantifica o desempenho e o comprometimento das equipes.',
    PERFORMANCE_COMPETENCES_CTA: 'Ver resultados',

    PERFORMANCE_FEEDBACK_LABEL: 'Desempenho',
    PERFORMANCE_FEEDBACK_TITLE: 'Feedback',
    PERFORMANCE_FEEDBACK_DESCRIPTION:
      'Melhore o desempenho do seu equipamento com feedback constante.',
    PERFORMANCE_FEEDBACK_CTA: 'Ver resultados',

    PERFORMANCE_PID_LABEL: 'Desempenho',
    PERFORMANCE_PID_TITLE: 'Plano de desenvolvimento individual',
    PERFORMANCE_PID_DESCRIPTION:
      'Criar processos para fechar gaps e promover o Talento Humano.',
    PERFORMANCE_PID_CTA: 'Criar PID',

    CLIMATE_SURVEY_LABEL: 'Clima',
    CLIMATE_SURVEY_TITLE: 'Pesquisas',
    CLIMATE_SURVEY_DESCRIPTION:
      'Ouça as necessidades das pessoas e crie uma cultura melhor.',
    CLIMATE_SURVEY_CTA: 'Monitorar o clima',

    CLIMATE_RECOGNITION_LABEL: 'Clima',
    CLIMATE_RECOGNITION_TITLE: 'Reconhecimento',
    CLIMATE_RECOGNITION_DESCRIPTION:
      'Gerenciar a cultura de reconhecimento por meio de medalhas.',
    CLIMATE_RECOGNITION_CTA: 'Ver detalhe',

    LEARNING_SKILL_EVOLUTION_LABEL: 'E-Learning',
    LEARNING_SKILL_EVOLUTION_TITLE: 'Skill XP Evolution',
    LEARNING_SKILL_EVOLUTION_DESCRIPTION:
      'Ele mede as habilidades do seu equipamento e detecta áreas de oportunidade e crescimento.',
    LEARNING_SKILL_EVOLUTION_CTA: 'Ver resultados',

    LEARNING_GROUP_STATISTICS_LABEL: 'E-Learning',
    LEARNING_GROUP_STATISTICS_TITLE: 'Trilhas de aprendizagem',
    LEARNING_GROUP_STATISTICS_DESCRIPTION:
      'Analisar o progresso de aprendizagem dos colaboradores.',
    LEARNING_GROUP_STATISTICS_CTA: 'Ver progresso',

    LEARNING_COURSES_LABEL: 'E-Learning',
    LEARNING_COURSES_TITLE: 'Cursos personalizados',
    LEARNING_COURSES_DESCRIPTION:
      'Gerencie o conteúdo de aprendizagem da sua organização e do planejamento de treinamento personalizado.',
    LEARNING_COURSES_CTA: 'Ver detalhe',

    CARD_LABEL_1: 'Desempenho',
    CARD_TITLE_1: 'Objetivos e competências',
    CARD_DESCRIPTION_1:
      'Quantifica o desempenho e o comprometimento das equipes.',
    CARD_CTA_1: 'Ver resultados',

    CARD_LABEL_2: 'Clima',
    CARD_TITLE_2: 'Pesquisas',
    CARD_DESCRIPTION_2:
      'Ouça as necessidades das pessoas e crie uma cultura melhor.',
    CARD_CTA_2: 'Monitorar o clima',

    CARD_LABEL_3: 'E-Learning',
    CARD_TITLE_3: 'Skill XP Evolution',
    CARD_DESCRIPTION_3:
      'Ele mede as habilidades do seu equipamento e detecta áreas de oportunidade e crescimento.',
    CARD_CTA_3: 'Ver resultados',

    CARD_LABEL_4: 'E-Learning',
    CARD_TITLE_4: 'Trilhas de aprendizagem',
    CARD_DESCRIPTION_4:
      'Analisar o progresso de aprendizagem dos colaboradores.',
    CARD_CTA_4: 'Ver progresso',

    CARD_LABEL_5: 'Desempenho',
    CARD_TITLE_5: 'Feedback',
    CARD_DESCRIPTION_5:
      'Melhore o desempenho do seu equipamento com feedback constante.',
    CARD_CTA_5: 'Ver resultados',

    CARD_LABEL_6: 'Clima',
    CARD_TITLE_6: 'Reconhecimento',
    CARD_DESCRIPTION_6:
      'Gerenciar a cultura de reconhecimento por meio de medalhas.',
    CARD_CTA_6: 'Ver detalhe',

    CARD_LABEL_7: 'Desempenho',
    CARD_TITLE_7: 'Plano de desenvolvimento individual',
    CARD_DESCRIPTION_7:
      'Criar processos para fechar gaps e promover o Talento Humano.',
    CARD_CTA_7: 'Criar PID',

    CARD_LABEL_8: 'E-Learning',
    CARD_TITLE_8: 'Cursos personalizados',
    CARD_DESCRIPTION_8:
      'Gerencie o conteúdo de aprendizagem da sua organização e do planejamento de treinamento personalizado.',
    CARD_CTA_8: 'Ver detalhe',

    // Home V2
    HEADER_V2_DESCRIPTION:
      'En este espacio, encontrarás las principales herramientas para tu crecimiento dentro de la compañía.',

    TITLE_1_MOBILE: 'Hola',

    CARDS_ENROLLED_COURSES_TITLE: 'Cursos inscritos',
    CARDS_ENROLLED_COURSES_DESCRIPTION:
      'Ingresa a los cursos que tienes asignados y continua con tu desarrollo.',
    CARDS_ENROLLED_COURSES_CTA: 'Ver mis cursos',
    CARDS_LEARNING_PATHS_TITLE: 'Rutas de aprendizaje',
    CARDS_LEARNING_PATHS_DESCRIPTION:
      'Potencia tus habilidades con contenido especializado y planificado para ti.',
    CARDS_LEARNING_PATHS_CTA: 'Ver mis rutas',

    PROFILE_CARD_VIEW_PROFILE: 'Ver perfil',
    PROFILE_CARD_OCCUPATION: 'Cargo',
    PROFILE_CARD_DEPARTMENT: 'Departamento',
    PROFILE_CARD_BOSS: 'Jefe',
    PROFILE_CARD_LOCATION: 'Sede',

    TALENT_CARD_TITLE: 'Procesos de Talento Humano',
    TALENT_CARD_TITLE_SHORT: 'Procesos de Talent',
    TALENT_CARD_DESCRIPTION:
      'Accede a guías y tutoriales para sacarle el máximo provecho a los cursos y funcionalidades de aprendizaje.',

    GREETINGS: 'Bom dia, {{name}}',
    DATE_PREPOSITION_DE: 'de',
    DATE_PREPOSITION_DEL: 'de',
  },
};

export default localePt;
